<template>
  <div class="interface">
    <!-- 导航栏 -->
    <!-- <div class="navigation">
      <div class="back"><<</div>
      <img :src="logUrlList.home" class="home_img" />
    </div> -->
    <!-- <button @click="test()">test</button> -->
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <!-- 申请制卡 -->
        <div class="applycard">
          <img :src="logUrlList.cat" />
          <div class="apply">
            <div class="apply_name">申请制卡</div>
            <div class="apply_button" @click="toApplyCard()">申请制卡</div>
          </div>
        </div>
        <hr />
        <!-- 进度查询 -->
        <div class="applycard">
          <img :src="logUrlList.dog" />
          <div class="apply">
            <div class="apply_name">查询进度</div>
            <div class="apply_button" @click="toQueryOrder()">查询进度</div>
          </div>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>
<script>
const logUrl = require("../../common/logUrl.js");
export default {
  name: "HomePage",
  data() {
    return {
      logUrlList: logUrl.logUrl,
    };
  },
  methods: {
    // test() {
    //   /**
    //    * 将图片URL转换为Base64编码的字符串
    //    * @param {string} url - 图片的URL
    //    * @returns {Promise<string>} - 返回一个Promise，解析为Base64编码的字符串
    //    */

    //   async function imageUrlToBase64(url) {
    //     try {
    //       const response = await fetch(url);
    //       if (!response.ok) {
    //         throw new Error(`HTTP error! status: ${response.status}`);
    //       }
    //       const blob = await response.blob();
    //       return new Promise((resolve, reject) => {
    //         const reader = new FileReader();
    //         reader.onloadend = () => {
    //           const base64data = reader.result;
    //           resolve(base64data.split(",")[1]); // 去掉data:image/png;base64,部分
    //         };
    //         reader.onerror = reject;
    //         reader.readAsDataURL(blob); // 读取为Base64格式
    //       });
    //     } catch (error) {
    //       console.error("There was a problem with the fetch operation:", error);
    //       throw error;
    //     }
    //   }

    //   // 使用示例
    //   const imageUrl =
    //     "https://ts.hengbao.net.cn:9010/dfs/group1/M00/00/54/rB-BemlSH9uARnG1AA5Ge91z3Lc736.png";
    //   imageUrlToBase64(imageUrl)
    //     .then((base64) => {
    //       console.log(base64);
    //     })
    //     .catch((error) => {
    //       console.error("Error converting image URL to Base64:", error);
    //     });
    // },
    test() {
      // 将图片URL转换为Base64的完整示例
      async function imageUrlToBase64(url) {
        const img = new Image();
        img.crossOrigin = "Anonymous"; // 关键配置
        img.src = url;
        return new Promise((resolve, reject) => {
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            const base64 = canvas.toDataURL("image/png"); // 转换为Base64
            resolve(base64);
          };
          img.onerror = () => reject("图片加载失败");
        });
      }

      // 使用示例
      imageUrlToBase64(
        "https://ts.hengbao.net.cn:9010/dfs/group1/M00/00/54/rB-BemlSH9uARnG1AA5Ge91z3Lc736.png"
      )
        .then((base64) => console.log(base64))
        .catch((err) => console.error(err));
    },
    // 申请制卡
    toApplyCard() {
      this.$router.push({
        name: "InformationFilling",
      });
    },
    // 进度查询
    toQueryOrder() {
      this.$router.push({
        name: "QueryOrder_demo",
      });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 1.8rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */
.applycard {
  background: url("../../../static/demoImage/查询进度.png") no-repeat center /
    cover;
  width: 100%;
  height: 8rem;
  border-radius: 0.6rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 2rem 1.6rem;
}
img {
  width: 6rem;
  height: 4rem;
}
.apply {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.apply_name {
  font-size: 1rem;
  font-weight: 900;
}
.apply_button {
  color: white;
  background-color: black;
  border-radius: 1rem;
  text-align: center;
  width: 5rem;
}

/* .footer {
  background-color: blue;
  height: 3rem;
} */
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/HomePage.vue